module.exports = __webpack_public_path__ + "static/media/circuit-bg.8b34f31e.jpg";